import React from "react";
import { Navigate, Route } from "react-router";
import { ProtectedRoute } from "./ProtectedRoute";
import SupportPage from "../features/Support/pages/SupportPage.tsx";
import { ActionItemsPage } from "pages/Support/ActionItems";
import SupportRequestPage from "../features/Support/pages/SupportRequestPage.tsx";
import SupportQuestionPage from "../features/Support/pages/SupportQuestionPage.tsx";
import SupportCasePage from "../features/Support/pages/SupportCasePage.tsx";

export const SupportRoutes = (
	<>
		{ProtectedRoute({
			path: "support",
			children: (
				<>
					<Route
						index
						element={
							<Navigate
								to="contact-us"
								replace
							/>
						}
					/>
					<Route
						path="contact-us"
						element={<SupportPage />}
					/>
					<Route
						path="request"
						element={<SupportRequestPage />}
					/>
					<Route
						path="request/questions"
						element={<SupportQuestionPage />}
					/>
					<Route
						path="request/order-help"
						element={<SupportCasePage isOrderHelp />}
					/>
					<Route
						path="request/problem"
						element={<SupportCasePage isOrderHelp={false} />}
					/>
				</>
			)
		})}
		<Route
			path="action-items"
			element={<ActionItemsPage />}
		/>
	</>
);
